import { AppImages, LocalStorageKeys, React } from '@/app'
import { AuthForms } from '@/components'
import { LocalStorage } from '@/utils'
import { useState } from 'react'
import { AuthModal } from './AuthModal'

const IMAGE_HEIGHT = 156

export const VerifyEmailBeforeModal = () => {
  const [hasSkipped, setHasSkipped] = useState(!!LocalStorage.getItem(LocalStorageKeys.HAS_SKIPPED_EMAIL_VERIFICATION))

  const onClose = () => {
    if (!hasSkipped) {
      LocalStorage.setItem(LocalStorageKeys.HAS_SKIPPED_EMAIL_VERIFICATION, true)
      setHasSkipped(true)
    }
  }

  return (
    <AuthModal
      image={AppImages.MailBox}
      name="verifyEmailBefore"
      imageHeight={IMAGE_HEIGHT}
      small
      centered={false}
      closable={!hasSkipped}
      onClose={onClose}
      center
    >
      <AuthForms.VerifyEmailBeforeForm />
    </AuthModal>
  )
}
